import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';

import { SPA_DIALOG, SpaModal } from '@services';

import { AlertComponentButtonConfig } from '../alert/alert.component';

@Component({
  selector: 'spa-error-alert',
  templateUrl: './error-alert.component.html',
  styleUrls: ['./error-alert.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorAlertComponent implements OnInit {
  private modal = inject<SpaModal<boolean>>(SPA_DIALOG);

  @Input() title = '';
  @Input() content = '';
  @Input() buttonText = '';
  button: AlertComponentButtonConfig | undefined;

  ngOnInit(): void {
    this.button = {
      label: this.buttonText,
      action: () => {
        this.modal.close(true);
      },
    };
  }
}
